'use strict';

import React, { Suspense, useState, useEffect } from 'react';
import {
  HashRouter,
  Redirect,
  Route,
  Switch,
  withRouter,
} from 'react-router-dom';

import { Toaster } from 'react-hot-toast';

import DockBar from '../components/dockbar/DockBar';
import Navigation from '../components/Navigation';
import TimelinePage from '../views/timeline/TimelinePage';
import UserInfo from '../views/userInfo/UserInfo';
import SendUserInfoRequest from '../views/userInfoRequest/sendUserInfoRequest';
import UserInfoRequestForm from '../views/userInfoRequest/userInfoRequestForm';
import Services from '../components/service/Services';
import TaysPolkuRedirect from '../views/tayspolku/Redirect';
import CoxaPolkuRedirect from '../views/coxapolku/Redirect';
import LibreviewRedirect from '../views/libreview/Redirect';
import ModalStack from '../components/ModalStack';
import NotFound from '../components/NotFound';

import '!style-loader!css-loader!sass-loader!../style.scss';
import { concat, get } from 'lodash';
import Row from '../components/tag/Row';
import Span from '../components/tag/Span';
import Urls from '../definitions/Urls';
import { connect } from 'react-redux';

import ErrorBoundary from './ErrorBoundary';
import {
  initializeUserInfo,
  updateUserInfo,
} from '../data/user/profile/actions';
import { updateInboxStatus } from '../data/user/officialServices/actions';
import {APPOINTMENTS, BIOBANK, FLOWMEDIK_CARECONVERSATIONS} from '../data/reducer';
import { notificationIdentity } from '../definitions/NotificationConstants';
import {
  BACKENDNOTIFICATIONS,
  NAV,
  QUESTIONNAIRES,
  TIMELINE,
  USER,
} from '../data/reducer';
import { selectIsHpa } from '../data/hpa/selectors';
import QuestionnaireRouter from '../components/questionnaire/QuestionnaireRouter';
import CareConversationRouter from '../components/careconversations/CareConversationRouter';
import Misc from '../definitions/Misc';
import {
  mapFimlabData,
  selectFimlabNotificationData,
} from '../views/timeline/data/selector';
import AppointmentRouter from '../components/appointment/AppointmentRouter';
import { initializeLoggedInApplication } from '../data/application/actions';
import { cookieChecker } from '../data/questionnaires/actions';
import BioBank from '../components/biobank/BioBank';
import {
  FEATURE_BIOBANK,
  FEATURE_USERINFOREQUEST,
  getFrontendProperties,
  isFeatureOn,
} from '../definitions/Config';
import { getTime } from '../utils/TimeUtils';
import FormResponse from '../components/form/FormResponse';
import Loader from '../components/Loader';

import AccessTokenProvider from '../context/AccessTokenContext';
import Session from '../utils/Session';
import { setLastActive } from '../data/session/actions';
import FormulaContextProvider from '../context/FormulaContext';
import FlowmedikCareConversationPage from "../components/careconversations/FlowmedikCareConversationPage";
import TimelineItemPage from "../views/timelineframe/TimelineFramePage";

const defaultLocale = 'fi_FI';

const MyErrorBoundary = withRouter(ErrorBoundary);

const ApplicationBase = (props) => {
  const {
    initializeLoggedInApplication,
    cookieChecker,
    timelineData,
    userInfo,
    notifications,
    questionnaireData,
    assignedForms,
    fimlabNotifications,
    careConversationNotifications,
    navigationModalIsVisible,
    consentData,
    queueAppointments,
    setLastActive,
  } = props;

  const [appStateValues, setAppStateValues] = useState({
    notifications: notifications,
    patientRelatives: null,
    navigationOpen: false,
    userDropdownOpen: false,
    navigationDropdownOpen: false,
    checkPhoneNumber: false,
    locale: defaultLocale,
  });
  const [timelineNotifications, setTimelineNotifications] = useState([]);
  const [queueArray, setQueueArray] = useState([]);
  const [appointmentNotificationsCount, setAppointmentNotificationsCount] =
    useState(null);
  const [navigationNotifications, setNavigationNotifications] = useState({
    notifications,
  });

  useEffect(() => {
    Misc.alterSkipToContent();

    initializeLoggedInApplication();
    cookieChecker();

    document.addEventListener(
      'click',
      (event) => {
        setLastActive(getTime());
      },
      []
    );

    // deduce locale if available
    let locale = 'fi';
    locale && setAppStateValues({ ...appStateValues, locale: locale });
  }, []);

  useEffect(() => {
    //filtering unapproved timeline items
    setTimelineNotifications(
      timelineData.filter((item) => {
        return !item.approved;
      })
    );
  }, [timelineData]);

  useEffect(() => {
    //setting up timeline notifications
    let tempTimelineNotifications = timelineNotifications;

    fimlabNotifications.forEach((item) => {
      let isFound = false;
      tempTimelineNotifications.forEach((tempItem) => {
        if (tempItem.id !== null && item.id === tempItem.id) {
          isFound = true;
        }
      })
      if (isFound === false) {
        tempTimelineNotifications.push(item);
      }
    })

    if (appStateValues.checkPhoneNumber) {
      tempTimelineNotifications.push('checkPhoneNumber');
    }
    setTimelineNotifications(tempTimelineNotifications);

    setNavigationNotifications({
      questionnaires: concat(
        get(questionnaireData.medixine, 'active', []),
        get(questionnaireData.omavointi, 'questionnaires', []),
        get(questionnaireData.medixine, 'started', []),
        assignedForms.filter(
          (form) => form.status === 'NULL' || form.status === 'DRAFT'
        )
      ),
      appointments: appointmentNotificationsCount,
      timeline: tempTimelineNotifications,
      services: servicesFilter(),
      careconversations: careConversationNotifications,
      biobank:
        isFeatureOn(FEATURE_BIOBANK) && userInfo.bioBankApplicable
          ? checkBioBankAgreement()
          : 0,
      viewinfo: getTime().isAfter(
        getTime(userInfo.userInfoTimestamp).add(
          ...Misc.contactReminderInterval()
        )
      )
        ? 1
        : 0,
    });
  }, [notifications, assignedForms, careConversationNotifications]);

  useEffect(() => {
    // set notification count for appointment nav-item
    setAppointmentNotificationsCount(queueArray.length);
  }, [queueArray]);

  useEffect(() => {
    // set queue appointments into an array after getting queueAppointments
    setQueueArray(queueAppointments.data);
  }, [queueAppointments]);

  const toggleNavigation = (newState) => {
    //toggle navigation, mobile navigation

    let open =
      newState !== undefined && typeof newState === 'boolean'
        ? newState
        : !appStateValues.navigationOpen;

    if (open !== appStateValues.navigationOpen)
      setAppStateValues({ ...appStateValues, navigationOpen: open });

    if (appStateValues.navigationDropdownOpen)
      setAppStateValues({ ...appStateValues, navigationDropdownOpen: false });
  };

  const toggleNavigationDropdown = () => {
    //toggle navigation dropdown
    setAppStateValues({
      ...appStateValues,
      navigationDropdownOpen: !appStateValues.navigationDropdownOpen,
    });
  };

  // TODO: make generic for the purpose of directing alerts to correct
  // TODO: tabs by convention (based on item key containing e.g. NAVIGATION_${NAVIGATIONKEY})
  const showInNavigation = (navigationTabName) => (item) => {
    return (
      item[notificationIdentity] &&
      item[notificationIdentity].match(new RegExp(navigationTabName, 'gi'))
    );
  };

  const checkBioBankAgreement = () => {
    // consentData is used to control bio bank agreement notifications.
    // consentData = "noContent" will show notification
    // consentData null, consentData "REFUSAL" or "CONSENT" as well as isHpa will not show notification
    if (
      userInfo.bioBankAgreement ||
      consentData === null ||
      (consentData && consentData.status === 'REFUSAL') ||
      (consentData && consentData.status === 'CONSENT') ||
      get(props, 'isHpa')
    ) {
      return 0;
    } else {
      return 1;
    }
  };

  const servicesFilter = () => {
    let servicesArray = [];

    const taysPolkuNotification = notifications.filter((notification) =>
      notification['notificationKey'].includes('TAYSPOLKU_PAGE_NOTIFICATION')
    );
    const coxaPolkuNotification = notifications.filter((notification) =>
      notification['notificationKey'].includes('COXAPOLKU_PAGE_NOTIFICATION')
    );
    const libreviewNotification = notifications.filter((notification) =>
      notification['notificationKey'].includes('LIBREVIEW_PAGE_NOTIFICATION')
    );

    if (
      taysPolkuNotification.length >= 1 &&
      taysPolkuNotification !== undefined
    ) {
      servicesArray.push(taysPolkuNotification[0]);
    }
    if (
      coxaPolkuNotification.length >= 1 &&
      coxaPolkuNotification !== undefined
    ) {
      servicesArray.push(coxaPolkuNotification[0]);
    }
    if (
      libreviewNotification.length >= 1 &&
      libreviewNotification !== undefined
    ) {
      servicesArray.push(libreviewNotification[0]);
    }
    return servicesArray;
  };

  return (
    <HashRouter>
      <div>
        <Session />
        <DockBar
          toggleNavigation={() => toggleNavigation()}
          checkPhoneNumber={appStateValues.checkPhoneNumber}
          userInfo={userInfo}
          notifications={navigationNotifications}
          logoLink={Urls.frontPageHistory}
        />
        <Row className="ot-maincontainer">
          <div></div>
          <Toaster
            containerClassName={'ot-session-toast'}
            position="top-center"
            reverseOrder={false}
          />
          <div>
            <Navigation
              outsideClickIgnoreClass="ot-dockbar__mobile"
              toggleNavigation={() => toggleNavigation()}
              toggleNavigationDropdown={() => toggleNavigationDropdown()}
              dropdownExtended={appStateValues.navigationDropdownOpen}
              open={appStateValues.navigationOpen}
              navigationModalOpen={navigationModalIsVisible}
              notifications={navigationNotifications}
            />
            <Span len="9" id="ot-mainview">
              <MyErrorBoundary>
                <Suspense fallback={<Loader />}>
                  <AccessTokenProvider>
                    <Switch>
                      <Route exact path="/">
                        <Redirect to={Urls.frontPageHistory} />
                      </Route>
                      <Route path="/timeline/:id" component={TimelineItemPage} />
                      <Route path="/timeline" component={TimelinePage} />
                      <Route
                        path="/questionnaires"
                        component={QuestionnaireRouter}
                      />
                      <Route path="/userinfo" component={UserInfo} />
                      {isFeatureOn(FEATURE_USERINFOREQUEST) && (
                        <Route path="/userinforequest/:id">
                          <FormulaContextProvider
                            formulaUrl={
                              getFrontendProperties().userinfoRequestFormulaUrl
                            }
                          >
                            <UserInfoRequestForm />
                          </FormulaContextProvider>
                        </Route>
                      )}
                      {isFeatureOn(FEATURE_USERINFOREQUEST) && (
                        <Route path="/userinforequest">
                          <FormulaContextProvider
                            formulaUrl={
                              getFrontendProperties().userinfoRequestFormulaUrl
                            }
                          >
                            <SendUserInfoRequest />
                          </FormulaContextProvider>
                        </Route>
                      )}
                      <Route
                        path="/careconversations"
                        component={FlowmedikCareConversationPage}
                      />
                      <Route
                        path="/appointments"
                        component={AppointmentRouter}
                      />
                      <Route
                        path="/questionnaires/response"
                        component={FormResponse}
                      />
                      {isFeatureOn(FEATURE_BIOBANK) && (
                        <Route path="/biobank" component={BioBank} />
                      )}
                      <Route path="/services" component={Services} />
                      <Route
                        path="/tayspolku/redirect"
                        component={TaysPolkuRedirect}
                      />
                      <Route
                        path="/coxapolku/redirect"
                        component={CoxaPolkuRedirect}
                      />
                      <Route
                        path="/libreview/redirect"
                        component={LibreviewRedirect}
                      />
                      <Route path="/">
                        <NotFound />
                      </Route>
                    </Switch>
                  </AccessTokenProvider>
                </Suspense>
              </MyErrorBoundary>
            </Span>
          </div>
        </Row>
        <ModalStack />
      </div>
    </HashRouter>
  );
};

const mapStateToProps = (state) => {
  const userInfo = state[USER].userInfo.data;
  const { data: timelineData } = state[TIMELINE];
  const { data: serviceNotifications } = state.services.notifications;
  const { data: notifications } = state[BACKENDNOTIFICATIONS];
  const { data: questionnaireData, assignedForms: assignedForms } =
    state[QUESTIONNAIRES];
  const { unreadMessageCount: careConversationNotifications } = state[FLOWMEDIK_CARECONVERSATIONS];
  const { navigationModalIsVisible: navigationModalIsVisible } = state[NAV];
  const fimlabNotifications = mapFimlabData(
    selectFimlabNotificationData(state)
  );
  const consentData = state[BIOBANK].consentData.data;
  const queueAppointments = state[APPOINTMENTS].queueAppointments;

  return {
    userInfo,
    timelineData,
    serviceNotifications,
    notifications,
    fimlabNotifications,
    questionnaireData,
    assignedForms,
    careConversationNotifications,
    isHpa: selectIsHpa(state),
    navigationModalIsVisible,
    consentData,
    queueAppointments,
  };
};

export default connect(mapStateToProps, {
  initializeLoggedInApplication,
  initializeUserInfo,
  updateUserInfo,
  updateInboxStatus,
  cookieChecker,
  setLastActive: setLastActive,
})(ApplicationBase);
